import type { Plugin } from "vue";

interface BaiduAnalyticsOptions {
  siteId: string;
}

declare global {
  interface Window {
    _hmt?: string[][];
  }
}

export const baiduAnalyticsPlugin: Plugin<BaiduAnalyticsOptions> = {
  install: (_app, options) => {
    const { siteId } = options;

    // Only load for .cn domains
    if (!window.location.hostname.includes(".cn")) {
      return;
    }

    // Initialize Baidu Analytics
    window._hmt = window._hmt || [];

    const script = document.createElement("script");
    script.src = `https://hm.baidu.com/hm.js?${siteId}`;
    script.async = true;

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode?.insertBefore(script, firstScript);
  },
};
